WiseMetering.Views.NewSpheraIntegration = WiseMetering.Views.Modal.Save.extend({
    className: 'mbx-info text-left',
    form_prefix: 'integration',
    template: 'templates/integrations/sphera/new',
    title: () => i18next.t('modal.title.integrations.new'),

    ui: {
        sites: '#integration_site_id',
        configuration: '#integration_configuration_id',
        indicators: '#integration_indicator_id',
        references: '#integration_reference_type',
        startSyncAt: '#integration_start_sync_at'
    },

    events: {
        'change @ui.sites': 'onSiteChange'
    },

    initialize: function(options) {
        WiseMetering.Views.Modal.Save.prototype.initialize.call(this, options);

        this.partner_id = WiseMetering.integrationLicenses.get(this.model.get('license_id')).get('partner_id');
    },

    getFormData: function() {
        let data = this.formSerializer();
        data.partner_id = this.partner_id;

        return data;
    },

    onRender: function() {
        const maxRetention = WiseMetering.currentOrganization.plan().get('data_retention');

        this.ui.startSyncAt.datepicker({
            dateFormat: 'yy-mm-dd',
            changeDay: true,
            changeMonth: true,
            changeYear: true,
            maxDate: moment().endOf('year').format('YYYY-MM-DD'),
            minDate: moment().add(-maxRetention, 'years').startOf('year').format('YYYY-MM-DD')
        });
    },

    onShow: function() {
        const
            sites = WiseMetering.zones.activeSites(),
            configurations = WiseMetering.integrationConfigurations.where({ license_id: this.model.license().id }),
            configurationOptions = WiseMetering.utils.optionsFromModels(configurations, 'name', null, configurations.length !== 1),
            referenceTypes = WiseMetering.utils.optionsFromArray(referenceTypesArray, null, 'id', 'name', true);

        this.ui.sites.html(WiseMetering.utils.optionsFromModels(sites, 'name', null, sites.length !== 1));
        this.ui.configuration.html(configurationOptions);
        this.ui.references.html(referenceTypes);
    },

    onSiteChange: function() {
        const selectedSiteId = this.ui.sites.val();

        if (!selectedSiteId) {
            this.ui.indicators.empty();
            return;
        }
        const
            usedIndicatorsIds = this.model.license().indicators().pluck('id'),
            availableIndicators = WiseMetering.indicators.models.filter(function(indicator) {
                const
                    utilities = ['water', 'active_energy'].includes(indicator.get('kind_slug')),
                    inSite = indicator.get('site_id') === selectedSiteId,
                    notUsed = !usedIndicatorsIds.includes(indicator.id);

                return utilities && inSite && notUsed;
            }),
            indicators = WiseMetering.utils.optionsFromModels(availableIndicators, 'name', null, availableIndicators.length !== 1);

        this.ui.indicators.html(indicators);
    },

    const: referenceTypesArray = [
        { id: 'Monitoring.MonthlyEnergyReport.6', name: 'CC1 - Consumption of electricity (excluding tenants) for covered car parking areas (lighting, ventilation) (kWh)' },
        { id: 'Monitoring.MonthlyEnergyReport.7', name: 'CC1 - Consumption of electricity (excluding tenants) for lighting and vertical transport (excluding car park already included above) (kWh)' },
        { id: 'Monitoring.MonthlyEnergyReport.8', name: 'CC1 - Consumption of electricity (excluding tenants) for the HVAC System (kWh)' },
        { id: 'Monitoring.MonthlyEnergyReport.9', name: 'CC1/ BC9 - Electricity consumption (excluding tenants) (kWh)' },
        { id: 'Monitoring.MonthlyEnergyReport.59', name: 'Electricity procured from grid (excluding tenants) (kWh)' },
        { id: 'Monitoring.MonthlyWaterReport.16', name: 'W1 - Water Consumption (excluding tenants) (m3)' }
    ]
});
